import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { ContentProvider } from './content/ContentContext.jsx'
import { AuthProvider } from './admin/AuthContext.jsx'
import { PublicSite } from './site/PublicSite.jsx'
import { ConsentBanner } from './site/ConsentBanner.jsx'
import { NotFound } from './site/NotFound.jsx'
import { useDocumentMeta } from './site/useDocumentMeta.js'
import AdminApp from './admin/AdminApp.jsx'
import './styles/site.css'

function PublicInner() {
  useDocumentMeta() // reads published content from ContentProvider
  return <PublicSite />
}

function PublicRoute() {
  return (
    <>
      <ContentProvider>
        <PublicInner />
      </ContentProvider>
      <ConsentBanner />
    </>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<PublicRoute />} />
          <Route path="/admin/*" element={<AdminApp />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}
